module.exports = __webpack_public_path__ + "static/media/icon-document.db85d937.svg";